import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { TokenType } from "../features/common2/Templating/WysiwygEditor";
import { client } from "../utils/axios-client";

const useTokenizedContent = (html: string, recordId: string, tokenType: TokenType, runOnce = false) => {
    const [tokenizedHtml, setTokenizedHtml] = useState('');
    const [stop, setStop] = useState(false);

    useEffect(() => {
        const tokenizeHtml = async () => {            
            if (isEmpty(html)) return;

            const response = await client.get('/api/options/tokenize', { params: { recordId: recordId, tokenType: tokenType, content: html } })
            setTokenizedHtml(response.data);

            if (runOnce) {                
                setStop(true);
            }
        }

        if (tokenType === TokenType.None || stop) {
            setTokenizedHtml(html);
        } else {
            tokenizeHtml();
        }
    }, [html])

    return { tokenizedHtml }
}

export { useTokenizedContent }